<template>
  <div class="answer_sheet">
    <div class="answer_top" v-if="examType == 'practice'">
      <div class="answer_title">答题卡</div>
      <div class="flex exam_info mar_top_10" v-if="schoolMenu != 3">
        <div class="exam_label">试卷名称：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ testExamInfo.paperName }}
        </div>
      </div>
      <!-- <div class="flex exam_info">
        <div class="exam_label">对应章节：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ testExamInfo.chapterName }}
        </div>
      </div> -->
      <div class="flex exam_info">
        <div class="exam_label">题目数量：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ testExamInfo.questionCount }}
        </div>
      </div>
      <div class="flex exam_info">
        <div class="exam_label">测试时长：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ testExamInfo.answerTime }}分钟
        </div>
      </div>
      <div class="flex exam_info" v-if="schoolMenu != 3">
        <div class="exam_label">试卷总分：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ testExamInfo.fullScore }}
        </div>
      </div>
      <div class="flex exam_info" v-if="testExamInfo.isShowScoring && schoolMenu != 3">
        <div class="exam_label">你的总分：</div>
        <div class="exam_value flex-1 toverflow mar_left_10">
          {{ finalScore }} <span class="notes">(仅做参考，不涉及人工判分)</span>
        </div>
      </div>
    </div>
    <div class="answer_top" v-if="examType == 'wrongQuestion'">
      题目序号
    </div>
    <div class="answer_top" v-if="examType == 'record'">
      <div class="flex FlexBaseline testExam_score Flexjustify">
        <div class="testExam_score_value">{{ testExamInfo.score }}</div>
        <div>分</div>
      </div>
      <div class="flex FlexBaseline Flexjustify">
        <el-image class="homework_score_icon" :src="iconPath('homework_score_icon.png')"></el-image>
      </div>
      <div class="marker_info px-15 py-20">
        <div class="flex Flexalign FlexWrap marker_info_content">
          <el-image class="comments_icon mr-10" :src="iconPath('comments_icon.png')"></el-image>
          <!-- <div class="" v-html="testExamInfo.markerComment" @click="handleImageClick"></div> -->
          <priviewImg :richText="testExamInfo.markerComment"></priviewImg>
        </div>
      </div>
      <div class="marker_reviewer flex Flexalign mt-10" v-if="testExamInfo.markerName">
        <div class="reviewer_label">批阅人：</div>
        <div class="reviewer_value">{{ testExamInfo.markerName }}</div>
      </div>
      <div class="marker_reviewer flex Flexalign mt-10" v-if="testExamInfo.markTime">
        <div class="reviewer_label">批阅时间：</div>
        <div class="reviewer_value">{{ testExamInfo.markTime }}</div>
      </div>
    </div>
    <div class="progress_classify flex FlexBetween mar_top_15" v-if="examType == 'practice' || examType == 'record'">
      <div class="classify_one flex Flexalign">
        <div class="complete_progress"></div>
        <div class="mar_left_10">
          {{ testExamInfo.isShowScoring ? "正确" : "已完成" }}
        </div>
      </div>
      <div class="classify_one flex Flexalign">
        <div class="incomplete_progress" :class="testExamInfo.isShowScoring ? 'wrong_progress' : ''"></div>
        <div class="mar_left_10">
          {{ testExamInfo.isShowScoring ? "错误" : "未完成" }}
        </div>
      </div>
      <div class="classify_one flex Flexalign">
        <div class="current_progress"></div>
        <div class="mar_left_10">
          {{ testExamInfo.isShowScoring ? "部分正确" : "当前" }}
        </div>
      </div>
    </div>
    <div class="topic_list mar_top_20" v-if="examType == 'practice' || examType == 'record'">
      <div class="topic_one mar_bottom_20" v-for="(item, index) in topicList" :key="index">
        <div class="topic_type">{{ item.topicType }}</div>
        <div class="topic_sub flex FlexWrap" v-if="!testExamInfo.isShowScoring">
          <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
            :class="[
              sitem.status == 0
                ? 'incomplete_progress'
                : sitem.status == 1
                  ? 'complete_progress'
                  : 'current_progress',
            ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
            {{ sitem.topicNum }}
          </div>
        </div>
        <div class="topic_sub flex FlexWrap" v-if="testExamInfo.isShowScoring">
          <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
            :class="[
              sitem.isCorrect == 1
                ? 'complete_progress'
                : sitem.isCorrect == 2
                  ? 'wrong_progress'
                  : 'current_progress',
            ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
            {{ sitem.topicNum }}
          </div>
        </div>
      </div>
    </div>
    <div class="topic_list mar_top_20" v-if="examType == 'wrongQuestion'">
      <div class="topic_one mar_bottom_20" v-for="(item, index) in topicList" :key="index">
        <div class="topic_type">{{ item.topicType }}</div>
        <div class="topic_sub flex FlexWrap">
          <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
            :class="[testExamInfo.currentQuestionId == sitem.questionNumber ? 'current_progress' : 'complete_progress'
            ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
            {{ sitem.topicNum }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="save_btn cursor_pointer"
      @click="saveProgress"
      v-if="!testExamInfo.isShowScoring"
    >
      保存进度，下次继续
    </div> -->
    <div class="commit_btn cursor_pointer" @click="commitPaper"
      v-if="!testExamInfo.isShowScoring && ((examType == 'wrongQuestion' && isWrongReubmit) || (schoolMenu != 4)) && schoolMenu != 3">
      提交试卷
    </div>
    <div class="commit_btn cursor_pointer" @click="composePaper"
      v-if="examType == 'wrongQuestion' && !isWrongReubmit && wrongTitle == '错题巩固'">
      错题组卷
    </div>
    <div class="attention_text" v-if="!testExamInfo.isShowScoring && schoolMenu != 3">
      若有主观题，系统暂不支持自动判分
    </div>

    <challengePopup ref="challengePopup"></challengePopup>
    <!-- 放五步组件为了控制完成后可切换下一步/下一章节阶段 -->
    <fiveStep v-show="false" :step="(schoolMenu - 1)"></fiveStep>
    <aiWait ref="aiWait"></aiWait>
  </div>
</template>

<script>
import { mapState } from "vuex";
import challengePopup from "@/components/popup/challengePopup.vue";
import priviewImg from "../richText/priviewImg.vue";
import fiveStep from "@/views/onlineLearning/components/fiveStep.vue";
import aiWait from "../popup/aiWait.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
export default {
  name: "GjkcH5AnswerSheet",
  computed: {
    ...mapState({
      testExamInfo: (state) => state.exam.testExamInfo,
      testExamTime: (state) => state.exam.testExamTime,
      isChallengeSubmit: (state) => state.exam.isChallengeSubmit,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      challengeSort: (state) => state.exam.challengeSort,
    }),
  },
  components: { challengePopup, priviewImg, fiveStep, aiWait, },
  props: {
    examType: {},
    schoolMenu: {},  // 用于判断是否是闯关，闯关不展示得分等信息
    isWrongReubmit: {},   // 用于控制错题重做还是练习，为true是重做，不展示组卷
    wrongTitle: {}, // 用于区分是经典错题还是用户错题，是否展示错题组卷按钮
    homeworkType: {},  // 用于区分是否是课后作业，课后作业接口要替换
  },
  emits: ['practiceBack', 'refreshTextExam'], // 显式声明事件
  inject: ["showWrongQuestion"],
  watch: {
    testExamTime: {
      handler(val) {
        if (val) {
          if (val.remainingTime <= 0) {
            this.commitPaper("timeout");
          }
        }
      },
      // immediate: true,
      deep: true,
    },
    testExamInfo: {
      handler() {
        this.organizeQuestionType();

        if (this.testExamInfo.isShowScoring) {
          // 计算总分
          this.getFinalScore();
        }
      },
      deep: true,
    },
  },
  unmounted() {
    this.$store.commit("exam/setTestExamTime", {});
  },

  data() {
    return {
      examInfo: {
        name: "",
        chapter: "",
        number: 20,
        duration: "",
        fullMark: 100,
      },
      topicList: [],
      finalScore: 0, // 总分
      paperCommitBackInfo: {},  // 闯关提交反馈结果
      loading: {},
    };
  },

  mounted() {
    this.organizeQuestionType();
  },

  methods: {
    getFinalScore() {
      this.finalScore = 0;
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          this.finalScore += Number(sitem.score);
        })
      })
    },
    changeCurrentQuestionId(id) {
      // 闯关模式不允许答题卡切换
      if (this.isChallengeSubmit) return
      this.$store.commit("exam/setCurrentQuestionId", id);
    },
    // 题型整理归纳
    organizeQuestionType() {
      this.topicList = [];
      if (this.$Tools.empty(this.testExamInfo)) return;
      const map = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十', '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七', '二十八', '二十九', '三十'];
      this.testExamInfo.paperContext.forEach((item) => {
        let topicInfo = {
          topicType: "",
          subList: [],
          questionTypeId: "",
        };
        item.questions.forEach((sitem) => {
          let isInProgress = 0; // 1已完成，2，进行中，0未完成
          if (sitem.questionContext?.isFinish) {
            isInProgress = 1;
          } else {
            isInProgress = 0;
          }
          // 判断题目是不是当前题目
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            isInProgress = 2;
          }
          // 查询题型是否已存在，存在则直接丢题目，否则创建题型列
          const currentIndex = this.topicList.findIndex(
            (ssitem) => item.questionTypeId == ssitem.questionTypeId
          );
          if (currentIndex != -1) {
            this.topicList[currentIndex].subList.push({
              ...sitem,
              topicNum: sitem.questionNumber,
              status: isInProgress,
            });
          } else {
            // if (sitem.questionTypeId == 1) {
            //   topicInfo.topicType = `${map[this.topicList.length]}、选择题`;
            // } else if (sitem.questionTypeId == 2) {
            //   topicInfo.topicType = `${map[this.topicList.length]}、多选题`;
            // } else if (sitem.questionTypeId == 4) {
            //   topicInfo.topicType = `${map[this.topicList.length]}、判断题`;
            // } else if (sitem.questionTypeId == 6) {
            //   topicInfo.topicType = `${map[this.topicList.length]}、排序题`;
            // } else if (sitem.questionTypeId == 3) {
            //   topicInfo.topicType = `${map[this.topicList.length]}、填空题`;
            // }
            topicInfo.topicType = `${map[this.topicList.length]}、${item.questionTypeName
              }`;
            topicInfo.questionTypeId = sitem.questionTypeId;
            topicInfo.subList.push({
              ...sitem,
              topicNum: sitem.questionNumber,
              status: isInProgress,
            });
            this.topicList.push(topicInfo);
          }
        });
      });
    },
    // 随堂练习返回
    practiceBack() {
      // let isHome = false;
      // let isChallenge = false;
      // let isFinalStep = false;
      // if(this.schoolMenu == 2){
      //   isHome= true;
      // }else if(this.schoolMenu == 3){
      //   isChallenge = true;
      // }else if(this.schoolMenu == 5){
      //   isFinalStep = true;
      // }
      // this.$emit("practiceBack", false,isHome,isChallenge,isFinalStep);
      this.$emit('practiceBack', false);
    },
    // 保存答题进度
    saveProgress() {
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: 2, // 是否提交：1：提交 2：未提交保存进度
        questions: [],
      };
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          listParams.questions.push(sitem);
        });
      });
      if (this.examType == "practice") {
        this.$Api.exam
          .savePractice(listParams)
          .then(() => {
            this.$Dialog.toast("保存成功");
            this.$emit("refreshTextExam");
            setTimeout(() => {
              this.practiceBack();
            }, 1000);
          })
          .catch(() => { });
      } else {
        this.$Api.exam
          .saveExam(listParams)
          .then(() => {
            this.$Dialog.toast("保存成功");
            this.$emit("refreshTextExam");
          })
          .catch(() => { });
      }
    },
    // 提交试卷
    commitPaper(type) {
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: 1, // 是否提交：1：提交 2：未提交保存进度,2现在改为最新后端判分处理
        questions: [],
      };
      let isAllFinish = true;
      if (this.testExamInfo.examScene) {
        listParams.examScene = this.testExamInfo.examScene
      }
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 深拷贝当前题目数据
          const questionCopy = JSON.parse(JSON.stringify(sitem));

          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (questionCopy.questionTypeId == 2) {
            if (Array.isArray(questionCopy.questionContext.answer)) {
              questionCopy.questionContext.answer = questionCopy.questionContext.answer.join(",")
            }
            if (Array.isArray(questionCopy.questionContext.doAnswer)) {
              questionCopy.questionContext.doAnswer = questionCopy.questionContext.doAnswer.join(",")
            }
            if (Array.isArray(questionCopy.doAnswer)) {
              questionCopy.doAnswer = questionCopy.doAnswer.join(",")
            }
          }
          if (questionCopy.questionTypeId == 99 || questionCopy.questionTypeId == 101 || questionCopy.questionTypeId == 102 || questionCopy.questionTypeId == 103) {
            questionCopy.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",")
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",")
                }
                // return aaa
              }
            });
          }
          // 作文题
          // 处理作文题序列化
          if (questionCopy.questionTypeId == 21 || questionCopy.questionTypeId == 22) {
            questionCopy.questionContext.doAnswer = JSON.stringify(questionCopy.doAnswer);
          }
          listParams.questions.push(questionCopy);
        });
      });
      if (this.isChallengeSubmit) {
        listParams.sort = this.challengeSort;
      }
      // compulsory  强制用户必须全部答完才可提交(非超时自动提交的情况)
      if (type != "timeout") {
        if (this.testExamInfo?.otherRule?.compulsory == 1) {
          this.testExamInfo.paperContext.forEach((item) => {
            item.questions.forEach((sitem) => {
              if (!sitem.questionContext?.isFinish) {
                isAllFinish = false;
                return
              }
            })
          })
          if (!isAllFinish) {
            this.$Dialog.toast("请检查是否全部答完，未答完不允许提交试卷", { type: 'warning' });
            return
          }
        }
      }
      // 错题重做提交
      if (this.isWrongReubmit) {
        this.wrongPaperCommit();
        return
      }
      this.$Dialog.confirm({
        message: type == "timeout" ? "考试时间到，请提交试卷" : "确认提交试卷",
        title: "提示", // 可选，不传则使用默认值'确认'
        onConfirm: () => {
          // if (this.examType == "practice") {
          //   this.$Api.exam
          //     .savePractice(listParams)
          //     .then((res) => {
          //       this.$Dialog.toast("提交成功");
          //       this.$emit("refreshTextExam");
          //       setTimeout(() => {
          //         // this.practiceBack();
          //         this.changeExamInfoIsShowScoring();
          //         if (this.isChallengeSubmit) {
          //           this.paperCommitBackInfo = res?.data?.data;
          //           this.getChallengeResult();
          //         }
          //       }, 1000);
          //     })
          //     .catch(() => { });
          // } else {
          // subjectiveQuestionMarking为1需要ai判分
          if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
            this.$refs.aiWait.aiWaitShow = true;
            this.saveExamInfo(listParams);
          } else {
            this.saveExamInfo(listParams);
          }
          // }
        }, // 确认后的操作，如调用删除API等
        onCancel: () => {

        }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
      });
    },
    // 错题重做提交
    wrongPaperCommit() {
      this.loading = this.$Dialog.loading('系统判分中，请耐心等待...');
      let listQuery = {
        courseId: this.selectLearningInfo.courseId,
        chapterId: this.selectLearningInfo.chapterId,
        schemeId: this.selectLearningInfo.schemeId,
        phaseId: this.selectLearningInfo?.id,
        roundId: this.selectLearningInfo.roundId,
        paperRecordJson: [],
        practiceType: 2,  // 1=预热练习, 2=正式纠错
        isSubmit: 1,  // 是否提交：1：提交 2：未提交
      };
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (sitem.questionTypeId == 2) {
            if (Array.isArray(sitem.questionContext.answer)) {
              sitem.questionContext.answer =
                sitem.questionContext.answer.join(",");
            }
            if (Array.isArray(sitem.questionContext.doAnswer)) {
              sitem.questionContext.doAnswer =
                sitem.questionContext.doAnswer.join(",");
            }
            if (Array.isArray(sitem.doAnswer)) {
              sitem.doAnswer = sitem.doAnswer.join(",");
            }
          }
          if (
            sitem.questionTypeId == 99 ||
            item.questionTypeId == 101 ||
            item.questionTypeId == 102 ||
            item.questionTypeId == 103
          ) {
            sitem.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",");
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",");
                }
                // return aaa
              }
            });
          }
          listQuery.paperRecordJson.push(sitem);
        });
      });
      this.$Api.exam.saveUserPhaseWrongQuestion(listQuery).then(res => {
        console.log(res.data.data);
        // this.$Dialog.toast("提交成功，需要再次查询作答记录");
        this.$emit("refreshTextExam");
        this.getUserWrongExamRecord(res?.data?.data?.recordId);
        this.loading.close();
      }).catch(() => {
        this.loading.close();
      })
    },
    // 试题提交
    saveExamInfo(listParams) {
      if (this.homeworkType == 'afterHomework') {
        this.$Api.exam
          .saveAfterHomework(listParams)
          .then((res) => {
            if (this.$refs.aiWait) {
              this.$Dialog.toast("提交成功");
              this.$refs.aiWait.aiWaitShow = false;
            }
            this.$emit("refreshTextExam");
            // 新增课后作业提交后（需批阅）返回列表，不停留在答题记录这
            if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 0) {
              this.$store.commit("exam/setExamIsBack", true);
            }
            setTimeout(() => {
              this.changeExamInfoIsShowScoring();
              // 此处加入判断，判断提交后当前步骤是否已完成，已完成则可以选择点击进入下一步/下一章节阶段
              this.judgeStepStatus();
              if (this.isChallengeSubmit) {
                this.paperCommitBackInfo = res?.data?.data;
                this.getChallengeResult();
                // // 此处新增系统判分逻辑----调用查询作答记录（后台判分）,用于刷新答题后状态
                this.getUserExamRecord(res?.data?.data?.recordId);
              } else {
                if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 0) {
                  this.$store.commit("exam/setExamIsBack", false); // 将状态重置为false
                } else {
                  this.loading = this.$Dialog.loading('系统判分中，请耐心等待...');
                }
                // // 此处新增系统判分逻辑----调用查询作答记录（后台判分）
                this.getUserExamRecord(res?.data?.data?.recordId);
              }
            }, 1000);
          })
          .catch(() => {
            this.$refs.aiWait.aiWaitShow = false;
          });
      } else {
        this.$Api.exam
          .saveExam(listParams)
          .then((res) => {
            if (this.$refs.aiWait) {
              this.$Dialog.toast("提交成功");
              this.$refs.aiWait.aiWaitShow = false;
            }
            this.$emit("refreshTextExam");
            setTimeout(() => {
              this.changeExamInfoIsShowScoring();
              // 此处加入判断，判断提交后当前步骤是否已完成，已完成则可以选择点击进入下一步/下一章节阶段
              this.judgeStepStatus();
              if (this.isChallengeSubmit) {
                this.paperCommitBackInfo = res?.data?.data;
                this.getChallengeResult();
                // // 此处新增系统判分逻辑----调用查询作答记录（后台判分）,用于刷新答题后状态
                this.getUserExamRecord(res?.data?.data?.recordId);
              } else {
                this.loading = this.$Dialog.loading('系统判分中，请耐心等待...');
                // // 此处新增系统判分逻辑----调用查询作答记录（后台判分）
                this.getUserExamRecord(res?.data?.data?.recordId);
              }
            }, 1000);
          })
          .catch(() => {
            this.$refs.aiWait.aiWaitShow = false;
          });
      }
    },
    judgeStepStatus() {
      let stepNum = this.schoolMenu;
      this.$Api.course
        .getMyCourseChapterProgress({
          schemeChapterPhaseId: this.selectLearningInfo?.id,
        }).then(res => {
          let stepStatus = 0;
          let labelText = "";
          // 2 作业，3 闯关 4 纠错 5 通关
          if (stepNum == 2) {
            stepStatus = res.data.data.outputStatus;
            labelText = "作业";
          } else if (stepNum == 3) {
            stepStatus = res.data.data.passStatus;
            labelText = "闯关";
          } else if (stepNum == 4) {
            // stepStatus = res.data.data.outputStatus;
          } else if (stepNum == 5) {
            stepStatus = res.data.data.finalStatus;
            labelText = "通关";
          }
          if (stepStatus == 1) {
            this.$Dialog.confirm({
              message: `当前${labelText}已全部完成，是否前往下一步`,
              title: "提示", // 可选，不传则使用默认值'确认'
              onConfirm: () => {
                // 退出答题页面
                this.practiceBack();
                setTimeout(() => {
                  this.$store.commit("learning/setStudyStepInfo", stepNum);
                }, 500)
              },
              onCancel: () => {
                this.practiceBack();
              },
            })
          } else {
            // 此处新增课堂作业人工判分返回效果
            if (this.homeworkType == 'seatwork') {
              this.$emit('backList');
            }
          }
        }).catch(() => { })
    },
    // 错题组卷
    composePaper() {
      // this.$Dialog.toast('功能开发中，敬请期待');
      let listQuery = {
        courseId: "",
        chapterId: "",
        schemeId: "",
        roundId: "",
        phaseId: "",
      };
      listQuery.chapterId = this.selectLearningInfo.chapterId;
      listQuery.courseId = this.selectLearningInfo.courseId;
      listQuery.schemeId = this.selectLearningInfo.schemeId;
      listQuery.roundId = this.selectLearningInfo.roundId;
      listQuery.phaseId = this.selectLearningInfo?.id;
      this.goWrongQuestionTest(1, false, '错题巩固', listQuery);
    },
    goWrongQuestionTest: debounce(
      function (type, flag, title, listQuery) {
        this.loading = this.$Dialog.loading('错题数据组卷中，请耐心等待...');
        // flag用于控制错题是经典错题还是错题巩固，数据接口返回数据格式不同。。。。。
        if (type == 1) {
          listQuery.practiceType = 2; // 1=预热练习（纠错练习），2=正式纠错（纠错重做）
          this.$Api.exam
            .getUserPhaseWrongQuestion(listQuery)
            .then((res) => {
              if (res.data.data.length == 0) {
                // this.$refs.noWrong.noWrongShow = true;
              } else {
                // this.goWrongQuestionTest(res.data.data, false, '错题巩固');
                this.showWrongQuestion(true, res.data.data, flag, false, title, true);
                this.loading.close();
                this.loading = {};
              }
            })
            .catch(() => {
              this.loading.close();
              this.loading = {};
            });
        }
      },
      300,
      false
    ),
    getChallengeResult() {
      // this.$Api.exam.getChallengeResult(this.selectLearningInfo.courseId, this.selectLearningInfo.schemeId, this.selectLearningInfo.roundId, this.selectLearningInfo?.chapterResource.schemeChapterPhaseId, this.selectLearningInfo.chapterId).then(res => {
      //   let resultInfo = res.data.data.filter(item => item.paperId == this.testExamInfo.paperId)[0];
      //   if (!this.$Tools.empty(resultInfo)) {
      this.$refs.challengePopup.isSuccess = (this.paperCommitBackInfo.isCorrect == 1) ? true : false;
      this.$refs.challengePopup.challengeInfo.num = this.paperCommitBackInfo.totalCount;
      this.$refs.challengePopup.challengeInfo.percent = this.paperCommitBackInfo.correctRate + "%";
      this.$refs.challengePopup.challengeInfo.time = this.$Tools.secondToMinuteFormatNew(this.paperCommitBackInfo.answerSection);
      this.$refs.challengePopup.challengePopupShow = true;
      // } else {
      //   this.$Dialog.toast("数据有误", { type: "warning" });
      // }
      this.$store.commit("exam/setIsChallengeSubmit", false);
      // }).catch(() => { })
    },
    // 试题提交控制显示试卷的结果分数
    changeExamInfoIsShowScoring() {
      this.testExamInfo.isShowScoring = true;
      // 默认到第一题
      this.testExamInfo.currentQuestionId = 1;
      this.$store.commit("exam/setTestExamInfo", this.testExamInfo);
    },
    // 此处新增系统判分逻辑----调用查询作答记录（后台判分）
    getUserExamRecord(recordId) {
      if (this.homeworkType == 'afterHomework') {
        this.$Api.exam.getAfterHomeworkRecordInfo(recordId).then(res => {
          let examInfo = res.data.data;
          examInfo.isShowScoring = true;

          // 第一次没有当前所做题目id设置第一个题目为当前所在题
          if (!examInfo.currentQuestionId) {
            examInfo.currentQuestionId =
              examInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
          }
          this.$store.commit("exam/setTestExamInfo", examInfo);
          this.loading.close();
          this.loading = {};
        }).catch(() => { })
      } else {
        this.$Api.exam.getUserExamRecord(recordId).then(res => {
          let examInfo = res.data.data;
          examInfo.isShowScoring = true;

          // 第一次没有当前所做题目id设置第一个题目为当前所在题
          if (!examInfo.currentQuestionId) {
            examInfo.currentQuestionId =
              examInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
          }
          this.$store.commit("exam/setTestExamInfo", examInfo);
          this.loading.close();
          this.loading = {};
        }).catch(() => { })
      }
    },
    // 此处新增系统判分逻辑----调用查询作答记录---错题重做（后台判分）
    getUserWrongExamRecord(recordId) {
      this.$Api.exam.getUserPhaseWrongQuestionRecordInfo(recordId).then(res => {
        let examInfo = res.data.data.paper;
        examInfo.isShowScoring = true;

        // 第一次没有当前所做题目id设置第一个题目为当前所在题
        if (!examInfo.currentQuestionId) {
          examInfo.currentQuestionId =
            examInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
        }
        this.$store.commit("exam/setTestExamInfo", examInfo);
        this.loading.close();
        this.loading = {};
      }).catch(() => { })
    }
  },
};
</script>

<style lang="scss" scoped>
.answer_sheet {
  width: 330px;
  // height: 847px;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px 20px;
  box-sizing: border-box;

  .answer_top {
    padding-bottom: 10px;
    border-bottom: 1px dashed #dedede;

    .answer_title {
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      text-align: center;
    }

    .exam_info {
      box-sizing: border-box;
      padding-left: 10px;
      line-height: 30px;
      // font-weight: 600;

      .exam_label {
        color: #999999;
      }

      .exam_value {
        color: #333333;

        .notes {
          font-size: 12px;
          color: rgb(153, 153, 153);
        }
      }
    }

    .testExam_score {
      font-size: 14px;
      color: #FD673B;

      .testExam_score_value {
        font-weight: 500;
        font-size: 32px;
        color: #FD673B;
      }
    }

    .homework_score_icon {
      width: 49px;
      height: 21px;
    }

    .marker_info {
      background: #F6FAFF;
      border-radius: 10px;
      font-size: 14px;
      color: #111111;

      .marker_info_content {
        width: 100%;
        overflow-wrap: anywhere;
      }

      .comments_icon {
        width: 62px;
        height: 27px;
      }
    }

    .marker_reviewer {
      .reviewer_label {
        width: 90px;
        font-size: 16px;
        color: #999999;
      }

    }
  }

  .progress_classify {
    .classify_one {
      color: #333333;
      // font-weight: 600;
    }
  }

  .topic_list {
    .topic_one {
      .topic_type {
        color: #333333;
        line-height: 24px;
      }

      .topic_sub {
        .answer_block {
          text-align: center;
          line-height: 24px;
          margin-right: 10px;
        }
      }
    }
  }

  .save_btn {
    width: 220px;
    height: 42px;
    border-radius: 21px;
    border: 1px solid #13d6aa;
    font-size: 18px;
    color: #13d6aa;
    text-align: center;
    line-height: 42px;
    margin: 80px auto 10px;
  }

  .commit_btn {
    width: 220px;
    height: 42px;
    background: #13d6aa;
    border-radius: 21px;
    font-size: 18px;
    text-align: center;
    line-height: 42px;
    color: #ffffff;
    margin: 10px auto;
  }

  .attention_text {
    font-size: 14px;
    color: #999999;
    margin: 15px auto;
    text-align: center;
  }
}

.complete_progress {
  width: 24px;
  height: 24px;
  background: rgba(0, 199, 88, 0.2);
  border-radius: 4px;
  border: 1px solid #00c758;
  color: #00c758;
}

.incomplete_progress {
  width: 24px;
  height: 24px;
  background: rgba(225, 225, 225, 0.2);
  border-radius: 4px;
  color: #999999;
  border: 1px solid #999999;
}

.current_progress {
  width: 24px;
  height: 24px;
  background: rgba(103, 139, 255, 0.2);
  border-radius: 4px;
  border: 1px solid #3a74f7;
  color: #3a74f7;
}

.wrong_progress {
  width: 24px;
  height: 24px;
  background: rgba(255, 20, 20, 0.23);
  border-radius: 4px;
  border: 1px solid #ff1414;
  color: #ff1414;
}

.marker_info {
  .markerComment {
    border: 1px solid #666;
    border-radius: 10px;
  }
}
</style>
